import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);
//引入一级路由
const Index = () => import("@/components/index");

//引入二级路由
const Home = () => import("@/components/view/home");
const Article_more = () => import("@/components/view/article_more");
const Article_details = () => import("@/components/view/article_details");
const Make_money = () => import("@/components/view/make_money");
export default new Router({
  routes: [{
      path: "/",
      component: Index,
      children: [{
          path: "/home",
          component: Home
        },
        {
          path: "/article_more",
          component: Article_more
        },
        {
          path: "/article_details",
          component: Article_details
        },
        {
          path: "/make_money",
          component: Make_money
        },
        {
          path: "",
          redirect: "/home"
        }
      ]
    },
    {
      path: "*",
      redirect: "/"
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js